import { methodGet, methodDelete, methodPost, methodPut, methodPatch } from './methods';
import { API_INFO } from '../constants';

export async function getValidateCode(code) {
  const url = API_INFO + `invoices/promo-codes/validate-code/${code}/`;
  return methodGet(url);
}